import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.widgets').controller('MsgFileUploadCtrl', MsgFileUploadCtrl);

  MsgFileUploadCtrl.$inject = ['$translate', 'PRINCIPAL'];

  /* @ngInject */
  function MsgFileUploadCtrl($translate, PRINCIPAL) {
    var vm;

    this.$onInit = function() {
      vm = this;
      getMsgFileUpload(vm.nomFichier);
    };

    // Récupérer le message à afficher pour le fichier téléchargé
    function getMsgFileUpload(nomFichier) {
      if (nomFichier) {
        // Récupération du nom du fichier dans le cas où on réçoit des chemin contenant des "/".
        nomFichier = nomFichier.replace(/^.*[\\/]/, '');
        if (nomFichier === 'logo.jpg' || nomFichier === 'logo_buyer.jpg') {
          vm.msg = PRINCIPAL.emailTemplateUploadResult.messageLogo;
        } else if (startsWith(nomFichier, PRINCIPAL.emailTemplateUploadResult.type[0])) {
          vm.msg = PRINCIPAL.emailTemplateUploadResult.messageFichier;
          vm.type = PRINCIPAL.emailTemplateUploadResult.type[0];
          vm.libelleLang = PRINCIPAL.emailTemplateUploadResult.libelleLang;
          vm.lang = getLang(nomFichier);
        } else if (startsWith(nomFichier, PRINCIPAL.emailTemplateUploadResult.type[1])) {
          vm.msg = PRINCIPAL.emailTemplateUploadResult.messageFichier;
          vm.type = PRINCIPAL.emailTemplateUploadResult.type[1];
          vm.libelleLang = PRINCIPAL.emailTemplateUploadResult.libelleLang;
          vm.lang = getLang(nomFichier);
        }
      }
    }

    // Récupérer la langue du fichier
    function getLang(nomFichier) {
      var reg = new RegExp('[_.-]+', 'g');
      var nomFichierTab = nomFichier.split(reg);
      var langue = $translate.instant('lang.' + (nomFichier.includes('buyer') ? nomFichierTab[2] : nomFichierTab[1]));
      var langueTab = langue.split(reg);

      return langueTab[1];
    }

    /** Vérifie si la chaine text contient au début la chaine startText. */
    function startsWith(text, startText) {
      return text.indexOf(startText) === 0;
    }
  }
})();
